import "./style.css";

import FixedOverflow from "../../lib";

new FixedOverflow({ elementSelector: ".header, .nav, .sidebar-menu" });
